/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { GenusOverviewRequestBuilderNavigationMetadata, GenusOverviewRequestBuilderRequestsMetadata, type GenusOverviewRequestBuilder } from './genusOverview/index.js';
// @ts-ignore
import { ProductAdministrationOverviewRequestBuilderNavigationMetadata, ProductAdministrationOverviewRequestBuilderRequestsMetadata, type ProductAdministrationOverviewRequestBuilder } from './productAdministrationOverview/index.js';
// @ts-ignore
import { ProductGroupOverviewRequestBuilderNavigationMetadata, ProductGroupOverviewRequestBuilderRequestsMetadata, type ProductGroupOverviewRequestBuilder } from './productGroupOverview/index.js';
// @ts-ignore
import { apiClientProxifier, ParseNodeFactoryRegistry, SerializationWriterFactoryRegistry, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type RequestAdapter } from '@microsoft/kiota-abstractions';
// @ts-ignore
import { FormParseNodeFactory, FormSerializationWriterFactory } from '@microsoft/kiota-serialization-form';
// @ts-ignore
import { JsonParseNodeFactory, JsonSerializationWriterFactory } from '@microsoft/kiota-serialization-json';
// @ts-ignore
import { MultipartSerializationWriterFactory } from '@microsoft/kiota-serialization-multipart';
// @ts-ignore
import { TextParseNodeFactory, TextSerializationWriterFactory } from '@microsoft/kiota-serialization-text';

/**
 * The main entry point of the SDK, exposes the configuration and the fluent API.
 */
export interface AapWebOdataClientV1 extends BaseRequestBuilder<AapWebOdataClientV1> {
    /**
     * Provides operations to manage the collection of GenusDto entities.
     */
    get genusOverview(): GenusOverviewRequestBuilder;
    /**
     * Provides operations to manage the collection of ProductAdministrationDto entities.
     */
    get productAdministrationOverview(): ProductAdministrationOverviewRequestBuilder;
    /**
     * Provides operations to manage the collection of ProductGroupDto entities.
     */
    get productGroupOverview(): ProductGroupOverviewRequestBuilder;
}
/**
 * Instantiates a new {@link AapWebOdataClientV1} and sets the default values.
 * @param requestAdapter The request adapter to use to execute the requests.
 */
// @ts-ignore
export function createAapWebOdataClientV1(requestAdapter: RequestAdapter) {
    if (requestAdapter === undefined) {
        throw new Error("requestAdapter cannot be undefined");
    }
    const serializationWriterFactory = requestAdapter.getSerializationWriterFactory() as SerializationWriterFactoryRegistry;
    const parseNodeFactoryRegistry = requestAdapter.getParseNodeFactory() as ParseNodeFactoryRegistry;
    const backingStoreFactory = requestAdapter.getBackingStoreFactory();
    
    if (parseNodeFactoryRegistry.registerDefaultDeserializer) {
        parseNodeFactoryRegistry.registerDefaultDeserializer(JsonParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(TextParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(FormParseNodeFactory, backingStoreFactory);
    }
    
    if (serializationWriterFactory.registerDefaultSerializer) {
        serializationWriterFactory.registerDefaultSerializer(JsonSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(TextSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(FormSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(MultipartSerializationWriterFactory);
    }
    
    if (requestAdapter.baseUrl === undefined || requestAdapter.baseUrl === null || requestAdapter.baseUrl === "") {
        requestAdapter.baseUrl = "http://localhost";
    }
    const pathParameters: Record<string, unknown> = {
        "baseurl": requestAdapter.baseUrl,
    };
    return apiClientProxifier<AapWebOdataClientV1>(requestAdapter, pathParameters, AapWebOdataClientV1NavigationMetadata, undefined);
}
/**
 * Uri template for the request builder.
 */
export const AapWebOdataClientV1UriTemplate = "{+baseurl}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AapWebOdataClientV1NavigationMetadata: Record<Exclude<keyof AapWebOdataClientV1, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    genusOverview: {
        requestsMetadata: GenusOverviewRequestBuilderRequestsMetadata,
        navigationMetadata: GenusOverviewRequestBuilderNavigationMetadata,
    },
    productAdministrationOverview: {
        requestsMetadata: ProductAdministrationOverviewRequestBuilderRequestsMetadata,
        navigationMetadata: ProductAdministrationOverviewRequestBuilderNavigationMetadata,
    },
    productGroupOverview: {
        requestsMetadata: ProductGroupOverviewRequestBuilderRequestsMetadata,
        navigationMetadata: ProductGroupOverviewRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
